module.exports = __webpack_public_path__ + "img/home.30d30fd9.svg";